
import React, { useEffect, useState } from 'react';
import { Input } from "antd";
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search_icon.gov.svg';
import '../../../../../../styles/pages/_searchBarComponent.scss';



const SearchComponent = (props) => {
    const prefix = <SearchIcon />;
    const { Search } = Input;
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(()=>{
        if(searchTerm.length>0) {
            const filteredGroups = props.allGroups.filter( group =>
                group.id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                group.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                group.type?.toLowerCase().includes(searchTerm.toLowerCase())
            )
            props.setDisplayedGroups(filteredGroups);
            props.setChecked(false);
            props.setSelectedGroups([]);
        } else {
            props.setDisplayedGroups(props.allGroups);
            props.setChecked(false);
            props.setSelectedGroups([]);
        }
    },[searchTerm])

    return (
        <div>
            <Search
                onChange={event => setSearchTerm(event.target.value) && props.setCurrentPage(1)}
                bordered={false}
                allowClear={true}
                prefix={prefix}
                className="sayt-input-filter input-filter"
                size="large"
                placeholder="Search with Group ID, Name, Type"
                enterButton
            />
        </div>
    );
};

export default SearchComponent;
